import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {BehaviorSubject, catchError, filter, Observable, of, switchMap, take, throwError} from 'rxjs';
import {environment} from '../../../environments/environment';
import {AuthService} from '../services/auth.service';
import {CommunicationService} from '../services/communication.service';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {

    private secureRoutes = [`${environment.api_url}`];
    private static ERROR_401_MESSAGE = 'Неверный логин или пароль';
    private isRefreshing = false; // Флаг для контроля обновления токена
    private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

    constructor(private authService: AuthService, private communicator: CommunicationService) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.secureRoutes.find((x) => request.url.startsWith(x))) {
            return next.handle(request);
        }

        console.info('request.url', request.url);
        //не обрабатываем ошибку по 'account/token/refresh'
        if (request.url.includes('account/token/refresh')) return next.handle(request);
        //при восставновлении пароля - пропускаем
        if (request.url.includes('api/user/passwordreset')) return next.handle(request);

        if (!request.url.includes('login')
            && !this.authService.isLoggedIn
            && !this.isRefreshing)
        {
            return this.handle401Error(request, next);
        }

        request = request.clone({
            withCredentials: true,
            setHeaders: {Authorization: `Bearer ${this.authService.token || ''}`}
        });

        return next.handle(request).pipe(
            catchError((error) => {
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    console.info('handle401Error', error);
                    return this.handle401Error(request, next);
                }
                return throwError(() => error);
            })
        );
    }

    private handle401Error(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
        // return next.handle(request)
        // Попытка обновить токен
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            return this.authService.refreshToken().pipe(
                switchMap(({refreshToken, token}: { token: string, refreshToken: string }) => {
                    this.isRefreshing = false;
                    this.authService.token = token;
                    this.authService.refreshTokenKey = refreshToken;

                    // Уведомляем всех, что токен обновлён
                    this.refreshTokenSubject.next(token);


                    const clonedRequest = request.clone({
                        setHeaders: {Authorization: `${token}`}
                    });
                    return next.handle(clonedRequest);
                }),
                catchError((refreshError) => {
                    this.isRefreshing = false;
                    this.refreshTokenSubject.next(null); // Сбрасываем состояние

                    this.authService.logout(); // Завершаем сессию

                    if (request.url.includes('api/user/restore-password')) return of()
                    return throwError(() => refreshError); // Прерываем запрос
                })
            )
        } else {
            return this.refreshTokenSubject.pipe(
                filter(token => token !== null), // Ждём, пока токен будет обновлён
                take(1), // Берём только первый результат
                switchMap(token => {
                    if (!token) {
                        // Если токен не обновился, прерываем запрос
                        this.authService.logout(); // Завершаем сессию
                        return throwError(() => new Error('Токен не был обновлён'));
                    }
                    const clonedRequest = request.clone({
                        setHeaders: {Authorization: `${token}`}
                    });
                    return next.handle(clonedRequest);
                })
            );
        }

    }
}

